import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Injectable, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UploadService } from '../../expense/services/upload.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent {
  infinity = Infinity;
  @Input() images: any;
  @Input() googleImages: any;
  @Input() isEditing: boolean = false;
  @Input() selectCount: number = Infinity;
  @Input() defaultSelect: boolean = true;
  @Input() disableUpload: boolean = false;
  @Output() uploadFiles = new EventEmitter<any>();
  selectedImages: any = [];
  filesToUpload: any = [];
  displayImages: any = [];
  @Input() showScrollButton: boolean = false;
  @ViewChild('imageGrid') imageGrid!: ElementRef;

  constructor(
    private awsService: UploadService,
    private cdRef: ChangeDetectorRef,
    private sharedImagesService: SharedImagesService
  ) { }

  ngOnInit() {
    if (this.images && this.images.length > 0) {
      this.initializeExistingFilesArray(this.images);
    }

    this.sharedImagesService.images.subscribe((images) => {
      this.googleImages = images;
      this.googleImages?.map((imageURL) => {
        if (!this.displayImages.some((image) => image.name === imageURL))
          this.displayImages.push(this.generateImagePayload(imageURL, { source: 'google' }));
      })
      this.cdRef.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['googleImages']) {
      this.googleImages.map((imageURL) => {
        if (!this.displayImages.some((image) => image.name === imageURL))
          this.displayImages.push(this.generateImagePayload(imageURL, { source: 'google' }));
      })
    }
    this.cdRef.detectChanges();
  }

  async initializeExistingFilesArray(files) {
    for (let item of files) {
      if (item.url) {
        const image = this.generateImagePayload(item.url, { name: item?.fileName, source: item?.source, mimeType: item?.fileType, id: item?.id, title: item?.title })
        this.displayImages.push(image);
        if (this.selectCount == this.infinity && this.defaultSelect)
          this.selectedImages.push(image);
      }
      else {
        this.awsService.getImageData(item.name, 'gallery').subscribe((res) => {
          if (res?.success?.data) {
            const image = this.generateImagePayload(res.success.data, { name: item?.name, source: item?.source, mimeType: item?.mimeType });
            this.displayImages.push(image);
            if (this.selectCount == this.infinity && this.defaultSelect)
              this.selectedImages.push(image);
          }
        });
      }
    }
    this.uploadFiles.emit({ selectedImages: this.selectedImages, filesToUpload: this.filesToUpload })
  }


  // Handle file selection from the user's computer
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      Array.from(input.files).forEach(file => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const imagePreview = { file: file, name: e.target.result, image: e.target.result, source: "upload" }
          this.selectedImages.push(imagePreview);
          this.displayImages.push(imagePreview);
          this.filesToUpload.push(imagePreview);
          this.upload();
        };
        reader.readAsDataURL(file);
      });
    }
  }

  // Toggle selection of an image
  toggleSelection(image: any) {
    const index = this.selectedImages.findIndex(img => img.image === image.image);
    if (index > -1) {
      this.selectedImages.splice(index, 1);
    } else {
      if (this.selectedImages.length >= this.selectCount) {
        return;
      }
      this.selectedImages.push(image);
    }

    const toUpload = this.images?.some((file) => (file.name === image.name || file.objectId === image.name)) || null;
    if (!toUpload) {
      const indexUpload = this.filesToUpload.findIndex(file => {
        return file.name === (image?.name || image?.image)
      });
      if (indexUpload > -1) {
        this.filesToUpload.splice(indexUpload, 1);
      }
      else {
        this.filesToUpload.push(image);
      }
    }

    this.upload();
  }

  isSelected(image: any): boolean {
    const result = this.selectedImages.some(
      img => img.image === image.image || img.name === image.name
    );
    return result;
  }

  async upload() {
    this.uploadFiles.emit({ selectedImages: this.selectedImages, filesToUpload: this.filesToUpload })
  }

  generateImagePayload(imageURL: string, options: any = null) {
    return {
      id: options?.id || null,
      image: imageURL,
      thumbImage: imageURL,
      source: options?.source || 'upload',
      name: options?.name || imageURL,
      mimetype: options?.mimeType || null,
      ...(options.title && { title: options?.title }),
      lazy: true
    }
  }
  selectAllImages(event) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.displayImages.map((image) => {
        const index = this.selectedImages.findIndex(img => img.image === image.image);
        if (index === -1) {
          this.selectedImages.push(image);
          const toUpload = this.images?.some((file) => file.name === image.name) || null;
          if (!toUpload) {
            const indexUpload = this.filesToUpload.findIndex(file => {
              return file.name === (image?.name || image?.image)
            });
            if (indexUpload > -1) {
              this.filesToUpload.splice(indexUpload, 1);
            }
            else {
              this.filesToUpload.push(image);
            }
          }
        }
      })
    }
    else {
      this.selectedImages = [];
      this.filesToUpload = [];
    }
    this.upload();
  }

  scrollLeft() {
    this.imageGrid.nativeElement.scrollBy({
      left: -300,
      behavior: 'smooth'
    });
  }

  scrollRight() {
    this.imageGrid.nativeElement.scrollBy({
      left: 300,
      behavior: 'smooth'
    });
  }
}

@Injectable({ providedIn: 'root' })
export class SharedImagesService {
  private imagesSubject = new BehaviorSubject<any[]>([]);
  images = this.imagesSubject.asObservable();

  updateImages(images) {
    this.imagesSubject.next(images);
  }

  getImages() {
    return this.imagesSubject.value;
  }


}
